
import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import HTMLDisplay from "../../../utils/HTMLDisplay";
import axios from "axios";
import "../../../assets/css/OtherNewsSection.css";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

function formatNewsDate(dateStr) {
  if (!dateStr) {
    return { month: "", day: "", year: "" };
  }

  const date = new Date(dateStr);

  if (Number.isNaN(date.getTime())) {
    return { month: "", day: "", year: "" };
  }

  return {
    month: date.toLocaleString("en-GB", { month: "short" }).toUpperCase(),
    day: date.getDate(),
    year: date.getFullYear(),
  };
}

function SpeechesSection({
  datacontent = [],
  initialPagination,
  id,
  type,
}) {
  const [newsList, setNewsList] = useState(datacontent || []);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState(
    initialPagination || {
      current_page: 1,
      last_page: 1,
    }
  );
  const [loading, setLoading] = useState(false);
  const headerTitle =
    datacontent[0]?.title.length > 0 ? datacontent[0]?.title : "Blank Page";
  const [error, setError] = useState(false);

  useEffect(() => {
    setNewsList(datacontent || []);
  }, [datacontent]);

  const fetchNews = useCallback(async () => {
    setLoading(true);
    setError(false);

    try {
      const endpoint =`${BASE_URL}posdata?pageName[eq]=${id}&columes[eq]=title_show_echo_03&ministry[eq]=1&status02[eq]=publish&status[eq]=Public&visibility[eq]=Public&display01[eq]=1&page=${page}&per_page=4`;

      const response = await axios.get(endpoint);

      const allData = response?.data?.allData || [];

      setNewsList(allData);
      setPagination(
        response?.data?.pagination || {
          current_page: page,
          last_page: 1,
        }
      );
    } catch (err) {
      console.error("Unable to load news:", err);
      setError(true);
    } finally {
      setLoading(false);
    }
  }, [type, id, page]);

  useEffect(() => {
    fetchNews();
  }, [fetchNews]);

  const currentPage = Number(pagination?.current_page || page);
  const lastPage = Math.max(
    1,
    Number(pagination?.last_page || 1)
  );

  const goToPage = (nextPage) => {
    const safePage = Math.max(1, Math.min(nextPage, lastPage));

    if (safePage !== page) {
      setPage(safePage);
    }
  };

  return (
    <section
      id="other-news"
      className="fmhud-news-section section"
    >
      <div className="container">
        {/* Section heading */}
        <div className="fmhud-news-heading">
          <div className="fmhud-news-heading-copy">
            <span className="fmhud-news-eyebrow">
              NEWS &amp; UPDATES
            </span>

            <h2>{headerTitle}</h2>
{/* 
            <p>
              Discover the latest news, activities and developments
              from the Federal Ministry of Housing and Urban Development.
            </p> */}
          </div>
          <div className="tm-modern-heading-mark" aria-hidden="true">
            <i className="fa-regular fa-newspaper" />
          </div>
        </div>

        {/* Loading state */}
        {loading && (
          <div
            className="fmhud-news-status"
            role="status"
            aria-live="polite"
          >
            <span className="fmhud-news-spinner" />
            <span>Loading latest news...</span>
          </div>
        )}

        {/* Error state */}
        {!loading && error && (
          <div className="fmhud-news-message" role="alert">
            <p>We could not load the news at this time.</p>
            <button
              type="button"
              className="fmhud-news-retry"
              onClick={fetchNews}
            >
              Try Again
            </button>
          </div>
        )}

        {/* News cards */}
        {!error && (
          <div className="row g-4 fmhud-news-grid">
            {newsList.map((item, index) => {
              const date = formatNewsDate(item.daterqw);

              const hasImage =
                typeof item.passport === "string" &&
                item.passport.trim() !== "" &&
                item.passport !== "undefined" &&
                item.passport !== "null";

              const imageUrl = hasImage
                ? `${BACKEND_URL}upload/${item.passport}`
                : null;

              return (
                <div
                  className="col-12 col-sm-6 col-lg-3"
                  key={item.id || index}
                >
                  <article
                    className="fmhud-news-card"
                    style={{ "--news-index": index }}
                  >
                    {/* Image */}
                    <Link
                      to={`/read/${item.id}`}
                      className={`fmhud-news-image ${
                        hasImage ? "" : "fmhud-news-no-image"
                      }`}
                      aria-label={`Read ${item.title || "news article"}`}
                    >
                      {hasImage ? (
                        <img
                          src={imageUrl}
                          alt={item.title || "Ministry news"}
                          loading="lazy"
                          decoding="async"
                        />
                      ) : (
                        <div className="fmhud-news-image-placeholder">
                          <span>fmhud</span>
                          <small>NEWS &amp; UPDATES</small>
                        </div>
                      )}

                      {date.month && (
                        <div className="fmhud-news-date">
                          <span className="fmhud-news-date-month">
                            {date.month}
                          </span>
                          <strong>{date.day}</strong>
                          <span className="fmhud-news-date-year">
                            {date.year}
                          </span>
                        </div>
                      )}

                      <span className="fmhud-news-image-arrow">
                        <i className="fa-solid fa-arrow-up-right-from-square" />
                      </span>
                    </Link>

                    {/* Article details */}
                    <div className="fmhud-news-card-body">
                      {item.caption && (
                        <div className="fmhud-news-caption">
                          <HTMLDisplay
                            html={item.caption}
                            textNo={12}
                            type="title"
                            textSize="0.8rem"
                          />
                        </div>
                      )}

                      <h3 className="fmhud-news-title">
                        <Link to={`/read/${item.id}`}>
                          <HTMLDisplay
                            html={item.story01 || item.title || ""}
                            textNo={14}
                            type="title"
                          />
                        </Link>
                      </h3>

                      <div className="fmhud-news-summary">
                        <HTMLDisplay
                          html={item.story01 || ""}
                          textNo={10}
                          type="body"
                        />
                      </div>

                      <div className="fmhud-news-card-footer">
                        <Link
                          to={`/read/${item.id}`}
                          className="fmhud-news-read-more"
                        >
                          Read Full Story
                          <i className="fa-solid fa-arrow-right" />
                        </Link>
                      </div>
                    </div>
                  </article>
                </div>
              );
            })}
          </div>
        )}

        {/* Empty state */}
        {!loading && !error && newsList.length === 0 && (
          <div className="fmhud-news-message">
            <i className="fa-regular fa-newspaper" />
            <p>No news articles are available at the moment.</p>
          </div>
        )}

        {/* Pagination */}
        {lastPage > 1 && !error && (
          <nav
            className="fmhud-news-pagination"
            aria-label="News pagination"
          >
            <span className="fmhud-news-page-info">
              Page <strong>{currentPage}</strong> of{" "}
              <strong>{lastPage}</strong>
            </span>

            <div className="fmhud-news-page-controls">
              <button
                type="button"
                onClick={() => goToPage(1)}
                disabled={currentPage <= 1 || loading}
                aria-label="First page"
              >
                <i className="fa-solid fa-angles-left" />
              </button>

              <button
                type="button"
                onClick={() => goToPage(currentPage - 1)}
                disabled={currentPage <= 1 || loading}
                aria-label="Previous page"
              >
                <i className="fa-solid fa-angle-left" />
              </button>

              <span className="fmhud-news-current-page">
                {currentPage}
              </span>

              <button
                type="button"
                onClick={() => goToPage(currentPage + 1)}
                disabled={currentPage >= lastPage || loading}
                aria-label="Next page"
              >
                <i className="fa-solid fa-angle-right" />
              </button>

              <button
                type="button"
                onClick={() => goToPage(lastPage)}
                disabled={currentPage >= lastPage || loading}
                aria-label="Last page"
              >
                <i className="fa-solid fa-angles-right" />
              </button>
            </div>
          </nav>
        )}
      </div>
    </section>
  );
}

export default React.memo(SpeechesSection);
